export const MEDIATYPES = () => [
  {
    text: 'min-width',
    value: 'minWidth'
  },
  {
    text: 'max-width',
    value: 'maxWidth'
  },
  {
    text: 'min-height',
    value: 'minHeight'
  },
  {
    text: 'max-height',
    value: 'maxHeight'
  },
  {
    text: 'exact',
    value: 'exact'
  }
]
